import {
  DEFAULT_SESSION_KIND,
  sanitizeSessionKind,
  type SessionKind,
} from '@/constants/session-kind'

interface RouteMeetingRow {
  id: string
  sessionKind?: SessionKind
}

/**
 * Which session kind the live/record routes should honour for `:id`.
 *
 * Global `settings.meetingSetup.sessionKind` only reflects the last create
 * flow; it must not decide routing for a different meeting id in the URL.
 */
export function resolveRouteSessionKind(
  routeMeetingId: string,
  {
    meetings,
    pendingStartMeetingId,
    settingsSessionKind,
  }: {
    meetings: RouteMeetingRow[]
    pendingStartMeetingId: string | null
    settingsSessionKind: SessionKind
  }
): SessionKind {
  const meeting = meetings.find((m) => m.id === routeMeetingId)
  if (meeting?.sessionKind) {
    return sanitizeSessionKind(meeting.sessionKind)
  }
  if (pendingStartMeetingId === routeMeetingId) {
    return sanitizeSessionKind(settingsSessionKind)
  }
  return DEFAULT_SESSION_KIND
}
